import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config

  const defaultButtonHeight = `calc(${tokens.button.defaultSize} - 2px)`
  const mobileButtonHeight = `calc(${tokens.button.mobileSize} - 2px)`

  const textBoxButtonStyles = {
    minWidth: '40px',
    maxHeight: defaultButtonHeight,

    [isTouchScreen]: {
      maxHeight: mobileButtonHeight,
      '& > button': {
        minHeight: mobileButtonHeight,
      },
    },
  }

  return {
    default: {
      textBoxStartElement: {
        '& > button': {
          minHeight: defaultButtonHeight,
          borderBottom: 'none',
          borderLeft: 'none',
          borderRadius: '1px 0 0 1px',
          borderTop: 'none',
        },
        ...textBoxButtonStyles,
      },

      textBoxEndElement: {
        '& > button': {
          minHeight: defaultButtonHeight,
          borderBottom: 'none',
          borderRadius: '0 1px 1px 0',
          borderRight: 'none',
          borderTop: 'none',
        },
        ...textBoxButtonStyles,
      },

      help: {
        marginInlineStart: '8px',
      },
    },
  } as const
}
